<template>
  <div :class="$style.container">
    <!-- <router-link :to="{ name: 'callouts' }">
      <CalloutsButton />
    </router-link> -->
    <div :class="$style.search">
      <SearchInput :value="search" ref="search" @clear="clearSearch" @input="onInput" />
    </div>
    <div ref="list" :class="$style.list">
      <ChatListItem
        v-if="isSearchInChat && activeChat"
        :chat="activeChat"
        isSearchInThisChat
        @clear-search="clearSearchInChat"
      />
      <template v-else>
        <template v-if="!chatListDisplay.length && !isChatsInited">
          <SidebarContentLoader />
          <SidebarContentLoader />
          <SidebarContentLoader />
        </template>
        <template v-else>
          <template v-if="$route.query.filter === 'invites' && availableInvitesMatrixRooms.length > 0">
            <ChatListItem
              v-for="chat in availableInvitesMatrixRooms"
              :key="chat.id"
              :chat="chat"
              :isActive="isChatActive(chat.id)"
              @click.native="setActiveChat(chat)"
            />
          </template>
          <template v-else>
            <ChatListItem
              v-for="chat in chatListDisplay"
              :key="chat.id"
              :chat="chat"
              :isActive="isChatActive(chat.id)"
              @click.native="setActiveChat(chat)"
            />
          </template>
          <!-- <infinite-loading @infinite="infiniteHandler"></infinite-loading> -->
        </template>
      </template>
      <div v-if="showSearchBlock && !isSearchInChat" :class="$style.searchBlock">
        <div v-if="foundUsers.length" :class="$style.section">
          <p :class="$style.searchTitle">{{ $t('search.myContacts') }}</p>
          <UserList
            :users="foundUsers"
            :avatarSize="56"
            mode="chat"
            :class="$style.searchUsersList"
            @go-to-chat="goToFoundUserChat"
          />
        </div>
        <div v-if="filteredAvailableUsers.length" :class="$style.section">
          <p :class="$style.searchTitle">{{ $t('search.globalSearch') }}</p>
          <UserList
            :users="filteredAvailableUsers"
            :avatarSize="56"
            mode="chat"
            :class="$style.searchUsersList"
            @go-to-chat="goToFoundUserChat"
          />
        </div>
        <div v-if="searchResult.length" :class="$style.section">
          <p :class="$style.searchTitle">{{ $t('chat.sidebarSearchMessages') }}</p>
          <div :class="$style.chatList">
            <ChatListItem
              v-for="message in searchResult"
              :key="message.id"
              :message="message"
              :chat="chatById(message.chatId)"
              @click.native="onFoundMessageClick(message.chatId)"
            />
          </div>
        </div>
      </div>
      <div v-if="isNotFound" :class="$style.empty">
        <p :class="$style.txt">{{ $t('search.notFound') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ChatListItem from './ChatListItem'
import SearchInput from '@/components/SearchInput'
import UserList from '@/components/UserList'
import { debounce } from 'lodash'
import SidebarContentLoader from '@/components/SidebarContentLoader'
import moment from 'moment'
import { chatNamesForBridge, messengerProviders } from '@/helpers/variables'
import { parseRouterQueryParam } from '@/helpers/index'
import api from '@/api'

const LIMIT = 40

const byActive =
  activeFilterId =>
    ({ chatFilterId }) =>
      chatFilterId === activeFilterId
const byCurrentFilters =
  filters =>
    ({ id }) =>
    // eslint-disable-next-line eqeqeq
      filters.some(({ chatId }) => chatId == id)
const byAllFilters =
  allFilters =>
    ({ id }) =>
    // eslint-disable-next-line eqeqeq
      !allFilters.some(({ chatFilterId, chatId }) => !!chatFilterId && id == chatId)

export default {
  name: 'chat-sidebar',
  components: {
    ChatListItem,
    SearchInput,
    UserList,
    SidebarContentLoader
  },
  metaInfo () {
    return {
      title: this.$t('tabChats')
    }
  },
  data () {
    return {
      search: '',
      searchResult: [],
      availableUsers: [],
      isSearchInChat: false
    }
  },
  created () {
    this.initChats()
  },
  computed: {
    ...mapGetters({
      chatList: 'entities/chats/myChats',
      chatById: 'entities/chats/getById',
      isChatsInited: 'entities/chats/isInited',
      searchChats: 'entities/chats/search',
      searchUsers: 'entities/users/search',
      currentChats: 'filter/currentChats',
      matrixRooms: 'matrix/rooms',
      matrixCredentials: 'matrix/matrixCredentials',
      inviteMatrixRooms: 'matrix/inviteRooms'
    }),
    availableInvitesMatrixRooms () {
      if (!this.matrixCredentials) return []
      return this.inviteMatrixRooms.filter(
        e =>
          (e.subProvider && e.subProvider === messengerProviders.whatsapp && this.matrixCredentials.isBridgeWhatsapp) ||
          (e.subProvider && e.subProvider === messengerProviders.telegram && this.matrixCredentials.isBridgeTelegram)
      )
    },
    availableMatrixRooms () {
      if (!this.matrixCredentials) return []
      return this.matrixRooms.filter(
        e =>
          (e.subProvider && e.subProvider === messengerProviders.whatsapp) ||
          (e.subProvider && e.subProvider === messengerProviders.telegram)
      )
    },
    filteredAvailableUsers () {
      return this.availableUsers?.filter(e => !(e?.nickname?.includes('wa:') || e?.nickname?.includes('tg:'))) || []
    },
    activeFilterId () {
      return parseRouterQueryParam(this.$route.query.filter) || 'all'
    },
    currentFilters () {
      return this.currentChats.filter(byActive(this.activeFilterId === 'all' ? null : this.activeFilterId))
    },
    chatListDisplay () {
      if (!this.searchQuery) {
        let list = [
          ...this.chatList.filter(chat => chat.properties && !chat.properties.pinCode),
          ...this.availableMatrixRooms.filter(
            e => e.name !== chatNamesForBridge.whatsapp && e.name !== chatNamesForBridge.telegram
          )
        ]
        if (this.activeFilterId === 'all') {
          list = list.filter(byAllFilters(this.currentChats))
        } else if (this.activeFilterId && this.activeFilterId !== 'invites') {
          list = list.filter(byCurrentFilters(this.currentFilters))
        }

        list.sort((a, b) => {
          const aLastMsg = a.provider ? a.lastMessages[0] : a.messages[0] || a.message
          const bLastMsg = b.provider ? b.lastMessages[0] : b.messages[0] || b.message
          return (
            moment((bLastMsg && bLastMsg.created) || Date.now()).valueOf() -
            moment((aLastMsg && aLastMsg.created) || Date.now()).valueOf()
          )
        })

        return list
      }
      return this.searchChats(this.searchQuery)
    },
    activeChatId () {
      return parseRouterQueryParam(this.$route.query.id, true)
    },
    activeChat () {
      return this.chatById(this.activeChatId)
    },
    foundUsers () {
      if (!this.searchQuery) return []
      return this.searchUsers(this.searchQuery)
    },
    searchQuery () {
      const search = this.search.trim()
      if (search.length < 3) return ''
      return search
    },
    showSearchBlock () {
      return this.foundUsers.length || this.foundUsers.length || this.searchResult.length
    },
    foundMessagesInChat () {
      if (this.isSearchInChat) return this.searchResult
      return null
    },
    isNotFound () {
      return this.searchQuery && !this.foundUsers.length && !this.availableUsers.length && !this.searchResult.lenght
    }
  },
  watch: {
    // foundMessagesInChat (foundMessagesInChat) {
    //   this.$store.commit('messages/SET_FOUND_MESSAGES', foundMessagesInChat)
    // },
    activeChatId: {
      handler (id) {
        this.$store.commit('entities/chats/SET_ACTIVE', id)
      },
      immediate: true
    },
    activeFilterId: {
      async handler (id) {
        if (id && id !== 'invites') {
          await this.getFilterChats()
        }
      },
      immediate: true
    },
    searchQuery (newValue, oldValue) {
      if (!newValue || newValue !== oldValue) {
        this.searchResult = []
        this.availableUsers = []
      }
      newValue && this.findAvailableUsers()
    },
    currentPageOfAvailableContacts () {
      return Math.floor(this.availableUsers.length / LIMIT) || 1
    },
    '$route.query.filter': {
      immediate: true,
      async handler () {
        await this.$nextTick()
        this.goTop()
      }
    }
  },
  methods: {
    ...mapActions({
      initChats: 'entities/chats/init',
      getFilterChats: 'filter/getFilterChats'
    }),
    setActiveChat (chat) {
      if (chat.constructor.entity === 'chats') {
        this.$router
          .push({ name: 'app-chat', query: { ...this.$route.query, id: window.btoa(chat.id) } })
          .catch(e => {})
      }
      if (chat.provider) {
        this.$router
          .push({ name: 'app-chat-matrix', query: { ...this.$route.query, id: window.btoa(chat.id) } })
          .catch(e => {})
      }
    },
    isChatActive (chatId) {
      if (!this.activeChatId) return false
      // eslint-disable-next-line eqeqeq
      return chatId == this.activeChatId
    },
    onInput: debounce(async function (query) {
      this.search = query
    }, 800),
    findAvailableUsers () {
      const params = { value: this.searchQuery, page: 1, limit: LIMIT }
      api.user.publicSearch({ params }).then(({ data }) => {
        this.availableUsers = data
      })
    },
    clearSearch () {
      this.search = ''
      this.searchResult = []
      this.availableUsers = []
    },
    goToFoundUserChat (chat) {
      this.clearSearch()
      this.setActiveChat(chat)
    },
    searchInChat () {
      this.isSearchInChat = true
      this.search = ''
      this.$refs.search.focus()
    },
    clearSearchInChat () {
      this.isSearchInChat = false
      this.clearSearch()
    },
    onFoundMessageClick (messageId) {
      // this.setActiveChat(message.chatId)
    },
    goTop () {
      if (!this.$refs.list) return
      this.$refs.list.scrollTop = 0
    }
  }
}
</script>

<style module lang="scss">
.container {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  overflow: hidden;
}
.list {
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: auto;
}
.search {
  padding: 15px;
}
.searchTitle {
  padding: 0 15px;
  font-weight: 500;
  color: $text-mid-dark;
}
.searchUsersList :global(.gl-user-list-item) {
  padding: 10px 15px;
  &:hover {
    background-color: rgba($main-bg-darkest, 0.1);
  }
}
.empty {
  align-items: center;
  display: flex;
  flex: 1;
  height: 100%;
  justify-content: center;
}
</style>
